module.exports = __webpack_public_path__ + "img/panty-ripper.7062f05e.jpg";